export const SIZES = {
  MEDIUM: 'medium',
  SMALL: 'small',
  XS: 'xs',
};

export const VARIANTS = {
  CONTAINED: 'contained',
  OUTLINED: 'outlined',
  ERROR: 'error',
  SUCCESS: 'success',
};
